import axios from "axios";

// Obtenez l'URL de base pour les appels API
export const getBackendMainUrl = () => {
  // Vous pouvez utiliser une variable d'environnement pour configurer l'URL de l'API
  return import.meta.env.VITE_API_URL || "http://localhost:3000/api";
};

// Créez une instance Axios avec des configurations de base
export const axiosInstance = axios.create({
  baseURL: getBackendMainUrl(),
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Intercepteur pour ajouter le token d'authentification à chaque requête
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authorization");
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les réponses et les erreurs
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Gérer les erreurs spécifiques (comme 401 Unauthorized)
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // Si vous avez un mécanisme de rafraîchissement de token, vous pouvez le gérer ici
      // Sinon, vous pouvez rediriger vers la page de connexion
      localStorage.removeItem("authorization");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);
